import React from 'react'
import { Field } from 'redux-form'
import TagPicker from 'components/TagPicker'
import isRequired from 'lib/isRequired'

const lower = value => {
  return value && value.toLowerCase()
}

const TagField = props => <TagPicker {...props} />

export const createTagFields = ({
  fieldCount,
  requiredCount,
  fieldName = 'tag',
  label = 'tags.tag_field',
  language = 'en'
}) => {
  return Array(fieldCount)
    .fill()
    .map((e, i) => {
      let name = `${fieldName}_${i}`
      let validators = i < requiredCount ? [isRequired] : []
      return (
        <Field
          key={name}
          name={name}
          language={language}
          label={label}
          hideLabel={!validators.length}
          component={TagField}
          normalize={lower}
          validate={validators}
          required={!!validators.length}
        />
      )
    })
}

export default TagField
